import styled from 'styled-components';

export const Article = styled.section`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 70px;
  width: 100%;
  margin-top: 20px;
  padding: 0 40px;

  &.YelloBackround {
    background-image: url('https://images.myloapp.in/angularAssets/YellowWave.svg');

    @media (max-width: 720px) {
      background-image: none;
    }
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 12px;
  }
`;

export const CardWrapper = styled.div`
  margin: 12px 0 4px;
  padding-bottom: 10px;
  cursor: pointer;
  transition:
    transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s,
    -webkit-transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s;

  &:hover {
    transform: scale(1.04);
  }
  @media (max-width: 720px) {
    flex-basis: 98%;
    cursor: default;
  }
`;

export const ArticleBox = styled.div`
  width: 100%;
  height: 200px;
`;

export const ArticleImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
`;

export const Title = styled.h2`
  font-size: clamp(18px, 2vw, 20px);
  color: rgb(0 0 0 / 80%);
  text-align: center;
  margin: 14px 0;
  letter-spacing: 3px;
`;

export const ArticleTitle = styled.h4`
  color: #6e6e6e;
  font-size: 12px;
  font-weight: 500;
  margin: 12px 0 0;

  @media (max-width: 720px) {
    height: ${(props) => (props.articlePage ? '15.2px' : 'auto')};
  }
`;

export const Content = styled.p`
  font-weight: 500;
  font-size: 16px;
  color: #000c;
  margin-top: 10px;

  @media (max-width: 720px) {
    height: ${(props) => (props.articlePage ? '38.4px' : 'auto')};
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  padding: 40px 0 56px;

  @media (max-width: 720px) {
    padding: 16px 10px 40px;
  }
`;

export const VermButton = styled.div`
  border: none;
  outline: none;
  background: #ef4e5e;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  max-width: ${(props) => (props.lg ? '1190px' : '760px')};
  text-align: center;
  width: 100%;
  height: 42px;
  line-height: 42px;
  border-radius: 6px;
  transition: all 0.6s ease;
  margin: 0 auto;
  @media (min-width: 720px) {
    cursor: pointer;
  }

  &:hover {
    background: #fff;
    border: 1px solid #ef4e5e;
    color: #ef4e5e;
  }
`;

export const Articlemargin = styled.div`
  margin: 2em 0 0;
`;
